import { Organisation } from '~organisations/domain';

import logo from './images/logo.png';

const taConfig: Organisation = {
  logo: logo,
  additionalOutcomeCaptureFields: {},
  asyncAdditionalOutcomeCaptureFields: {},
  contactAssessmentForms: {},
};

export default taConfig;
